import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const api = {
  // PS Units
  listUnits: () => client.get('/ps-units').then(r => r.data),
  createUnit: (data) => client.post('/ps-units', data).then(r => r.data),
  updateUnit: (id, data) => client.patch(`/ps-units/${id}`, data).then(r => r.data),
  deleteUnit: (id) => client.delete(`/ps-units/${id}`).then(r => r.data),
  tvPower: (id, action) => client.post(`/ps-units/${id}/tv/power`, { action }).then(r => r.data),
  getConfig: () => client.get('/config').then(r => r.data),

  // Rentals
  listRentals: (status) => client.get('/rentals', { params: status ? { status } : {} }).then(r => r.data),
  startRental: (data) => client.post('/rentals/start', data).then(r => r.data),
  stopRental: (id) => client.post(`/rentals/${id}/stop`, {}).then(r => r.data),
  extendRental: (id, extraHours) => client.post(`/rentals/${id}/extend`, { extra_hours: extraHours }).then(r => r.data),
  deleteRental: (id) => client.delete(`/rentals/${id}`).then(r => r.data),

  // Food
  listFoods: () => client.get('/food-items').then(r => r.data),
  createFood: (data) => client.post('/food-items', data).then(r => r.data),
  updateFood: (id, data) => client.patch(`/food-items/${id}`, data).then(r => r.data),
  restockFood: (id, qty) => client.post(`/food-items/${id}/restock`, { qty }).then(r => r.data),
  deleteFood: (id) => client.delete(`/food-items/${id}`).then(r => r.data),

  // Sales
  listSales: () => client.get('/food-sales').then(r => r.data),
  createSale: (data) => client.post('/food-sales', data).then(r => r.data),

  // Dashboard
  summary: () => client.get('/dashboard/summary').then(r => r.data),
  dailyChart: (days = 7) => client.get('/dashboard/daily-chart', { params: { days } }).then(r => r.data),
  allTransactions: () => client.get('/dashboard/transactions').then(r => r.data),

  seed: () => client.post('/seed').then(r => r.data),
};
